import React from 'react';
import { Link } from 'react-router-dom';

const PublicPageFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-6 text-center">
      <div className="flex items-center justify-center gap-1.5 text-xs text-gray-400 flex-wrap">
        <span>&copy; {currentYear} ProBiz Pay LLC</span>
        <span className="text-gray-300">&middot;</span>
        <Link to="/privacy" className="hover:text-gray-600 transition-colors">
          Privacy
        </Link>
        <span className="text-gray-300">&middot;</span>
        <Link to="/terms" className="hover:text-gray-600 transition-colors">
          Terms
        </Link>
        <span className="text-gray-300">&middot;</span>
        <Link to="/cookies" className="hover:text-gray-600 transition-colors">
          Cookies
        </Link>
        <span className="text-gray-300">&middot;</span>
        <Link to="/acceptable-use" className="hover:text-gray-600 transition-colors">
          Acceptable Use
        </Link>
      </div>
    </footer>
  );
};

export default PublicPageFooter;
